import React from 'react'

import COLORS from '../../../styles/colors'

const defaultSize = {
  width: 27,
  height: 27,
}

const Area = ({ style = {}, color = COLORS.brand.primary }) => (
  <svg xmlns='http://www.w3.org/2000/svg' style={{ ...defaultSize, ...style }} viewBox='0 0 27 27'>
    <g
      stroke={color}
      fill={COLORS.greyscale.white}
      transform='translate(0.5 0.5)'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeMiterlimit='10'
      strokeWidth='1'
    >
      <path d='M138,370.672h8.65v-8.65H138Z' transform='translate(-138 -362.022)' />
      <path d='M146.369,370.672h8.65v-8.65h-8.65Z' transform='translate(-137.719 -362.022)' />
      <path d='M154.74,370.672h8.65v-8.65h-8.65Z' transform='translate(-137.437 -362.022)' />
      <path d='M138,379.041h8.65v-8.65H138Z' transform='translate(-138 -361.741)' />
      <path d='M146.369,379.041h8.65v-8.65h-8.65Z' transform='translate(-137.719 -361.741)' />
      <path d='M138,387.411h8.65v-8.65H138Z' transform='translate(-138 -361.459)' />
    </g>
  </svg>
)

export default Area
